import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import Icon from '../common/icon';
import { bbCodeToHtml } from '../../utils/formUtils';
import './style.scss';

export enum ErrorType {
  GLOBAL_ERROR,
  FORM_ERROR,
}

export interface ErrorProps {
  message: string;
  type?: ErrorType;
}

interface Props {
  errors: Array<ErrorProps>;
}
const renderItem = (error: ErrorProps) => {
  const { message, type } = error;
  return (
    <div
      key={message}
      styleName={cn('notify__item', {
        formError: type === ErrorType.FORM_ERROR,
        globalError: type === ErrorType.GLOBAL_ERROR,
      })}
    >
      <div styleName="notify__item__icon">
        <Icon value="warning" />
      </div>
      <span
        styleName="notify__item__text"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: bbCodeToHtml(message),
        }}
      />
    </div>
  );
};
const Notify: React.FC<Props> = ({ errors }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 150);
  }, []);
  const children = errors.map(e => renderItem(e));
  return (
    <div styleName={cn('notify', { show })} data-cy-prop="errorMsg">
      {children}
    </div>
  );
};
export default Notify;
